import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Hind

  <span style="color:#85c1dc;">**FI:**</span>
  Asiakashinta

  <span style="color:#85c1dc;">**RU:**</span>
  Цена для обычных клиентов
*/
/* @__NO_SIDE_EFFECTS__ */
const m816 = msg(
  mf`Hind`,
  mf`Asiakashinta`,
  mf`Цена для обычных клиентов`,
)

export { m816 as 'w.module.product_hero.customer_price' }